import { render, staticRenderFns } from "./patientForm.vue?vue&type=template&id=47715b8b&scoped=true"
import script from "./patientForm.vue?vue&type=script&lang=js"
export * from "./patientForm.vue?vue&type=script&lang=js"
import style0 from "./patientForm.vue?vue&type=style&index=0&id=47715b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47715b8b",
  null
  
)

export default component.exports